/*
 * Локальний стан браузера, пов'язаний з роботою працівника: що прибирати під час виходу.
 * Лишаються лише налаштування пристрою (тема, згорнута бічна панель, режим навчання) і персональні переліки,
 * ключ яких містить ідентифікатор працівника й у яких немає нічого, крім ідентифікаторів проєктів
 * (обрані й останні проєкти) — інший працівник їх не читає.
 */

const PREFIXES = ['ers.', 'kb.'];
const KEEP_EXACT = new Set(['ers.theme', 'ers.sidebar.collapsed', 'ers.training', 'ers.training.seen', 'ers.logout-pending']);
const KEEP_PREFIXES = ['ers.fav-projects.', 'ers.recent-projects.', 'ers.last-project.'];

function sweep(storage: Storage, keep: (key: string) => boolean) {
  const keys: string[] = [];
  for (let i = 0; i < storage.length; i++) {
    const k = storage.key(i);
    if (k && PREFIXES.some((p) => k.startsWith(p)) && !keep(k)) keys.push(k);
  }
  for (const k of keys) storage.removeItem(k);
}

/** Вихід або зміна особи: прибрати стан екранів (фільтри, згорнуті групи, відповіді незавершеного тесту). */
export function clearUserLocalState() {
  try {
    sweep(window.localStorage, (k) => KEEP_EXACT.has(k) || KEEP_PREFIXES.some((p) => k.startsWith(p)));
  } catch {
    /* сховище недоступне */
  }
  try {
    sweep(window.sessionStorage, () => false);
  } catch {
    /* сховище недоступне */
  }
}
